import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import Config from "../../config/Config";
import { handleLongText } from "../../config/global";
import { ViolationPointCard } from "../cardComponent/violationPointCard";
import { comboMasterReward, imageViolation, requestReward } from "../../core/service/api_violation_point";

const ViolationPointFormMobile = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>(props.data);
  const [masterReward, setMasterReward] = useState<any>([])
  const [masterRewardId, setMasterRewardId] = useState('')
  const [point, setPoint] = useState(0)
  const [date, setDate] = useState(moment().format("yyyy-MM-DD"))
  const [studentSelected, setStudentSelected] = useState('')
  const [preview, setPreview] = useState('')
  const [description, setDescription] = useState('')
  const [bukti, setBukti] = useState(null)
  const previewImage = (event: any) => {
    const file = event.target.files[0];
    setBukti(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) { }
  }, [location.pathname.split("/")[2]]);

  function closeModal() {
    setIsOpen(false);
  }

  const handleRefresh = async () => { };

  const goToDetail = async (data: string) => {
    navigate(`/attendance-detail`, {
      state: {
        data: JSON.stringify(data),
        date: moment().format("yyyy-MM-DD"),
      },
    });
  };

  const fetchComboMasterReward = async () => {
    try {
      let query: any = [];
      const response = await comboMasterReward(query)
      console.log(response)
      setMasterReward(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const changeMasterReward = (e: any) => {
    setMasterRewardId(e.target.value)
    if (e.target.value == '') return setPoint(0)
    setPoint(masterReward.find((item: any) => item._id == e.target.value).point)
  }

  const changeStudent = (e: any) => {
    setStudentSelected(e.target.value)
  }

  const saveData = async () => {
    let data = {
      studentId: studentSelected,
      masterRewardId: masterRewardId,
      date: date,
      description: description,
      photoUrl: bukti
    }
    props.saveData(data)
  }

  useEffect(() => {
    fetchComboMasterReward()
    if (props.students.length == 1) setStudentSelected(props.students[0]?.id)
  }, [])

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[95dvh]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div
                  className="bg-white p-3 rounded-xl flex-row flex gap-1 items-center flex-0 w-full justify-between"
                >
                  <form>
                    <div className="flex flex-col">
                      <div>
                        <label className="control-Label required" htmlFor="name">
                          Nama
                        </label>
                      </div>
                      <div>
                        <div className="mb-2">
                          <select
                            value={studentSelected}
                            onChange={(e) => changeStudent(e)}
                            className="py-2 px-3 w-full border rounded-lg disabled:text-gray-500"
                          >
                            <option disabled value="">
                              pilih
                            </option>
                            {props.students.map((item: any) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      className="flex gap-1">

                      <div className="flex flex-col">
                        <div>
                          <label className="control-Label required" htmlFor="reward">
                            Reward
                          </label>
                        </div>
                        <div>
                          <div className="mb-2">
                            <select
                              value={masterRewardId}
                              onChange={(e) => changeMasterReward(e)}
                              className="py-2 px-3 w-full border rounded-lg disabled:text-gray-500"
                            >
                              <option disabled value="">
                                pilih
                              </option>
                              {masterReward.map((item: any) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col w-20">
                        <div>
                          <label className="control-Label" htmlFor="point">
                            Point
                          </label>
                        </div>
                        <div >
                          <input
                            disabled
                            type="text"
                            className="form-control"
                            value={point}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div>
                        <label className="control-Label required" htmlFor="date">
                          Tanggal
                        </label>
                      </div>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div>
                        <label className="control-Label " htmlFor="description">
                          Keterangan
                        </label>
                      </div>
                      <div>
                        <textarea
                          rows={2}
                          name="description"
                          className="form-control"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div>
                        <label className="control-Label" htmlFor="bukti">
                          Bukti
                        </label>
                      </div>
                      <div className="d-flex flex-column">
                        <input
                          onChange={(e) => previewImage(e)}
                          type="file"
                          className="form-control"
                        />
                        <span>file Format jpg dan png 2 mb</span>
                      </div>
                      <div>
                        <img src={preview} alt="Bukti" className="img-fluid rounded-3 size-20" />
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => saveData()}
                        className="flex flex-row gap-2 px-3 py-1 border-1 border-[#0054e6] text-[#0054e6] font-medium text-md rounded-md"
                      >
                        Request
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      Pilih
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">

                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ViolationPointFormMobile;
